import {
  InstagramLogoIcon,
  LinkedinLogoIcon,
  YoutubeLogoIcon,
} from "@phosphor-icons/react/dist/ssr";

export const footerLink = [
  {
    title: "Products",
    children: [
      { title: "AI Interviews", to: "/product/ai-interviews" },
      { title: "AI Phone Screener", to: "/product/ai-phone-screener" },
      { title: "JD–CV Matching", to: "/product/jd-cv-matching" },
      { title: "Coding Assessment", to: "/product/coding-assessment" },
      { title: "AI Proctoring", to: "/product/ai-proctoring" },
    ],
  },
  {
    title: "Platform",
    children: [
      { title: "Multi-Language Support", to: "/product/languages" },
      { title: "ATS Integrations", to: "/product/ats-integrations" },
      { title: "WhatsApp Dashboard", to: "/product/whatsapp-dashboard" },
    ],
  },
  // {
  //   title: "Solutions",
  //   children: [
  //     { title: "Enterprises", to: "/solutions/enterprises" },
  //     { title: "Startups", to: "/solutions/startups" },
  //     { title: "Recruitment Agencies", to: "/solutions/recruitment-agencies" },
  //     { title: "Educational Institutions", to: "/solutions/institutions" },
  //     { title: "AI Research Labs", to: "/solutions/ai-labs" },
  //   ],
  // },
  {
    title: "Use Cases",
    children: [
      { title: "Technical AI Recruiter", to: "/use-cases/technical-ai-recruiter" },
      { title: "AI Campus Drives", to: "/use-cases/ai-campus-drives" },
      { title: "High Volume Recruiter", to: "/use-cases/high-volume-recruiter" },
      { title: "Diversity Hiring", to: "/use-cases/diversity-hiring" },
      { title: "Universal AI Recruiter", to: "/use-cases/universal-ai-recruiter" },
    ],
  },
  {
    title: "Company",
    children: [
      { title: "About Us", to: "/resources/aboutus" },
      { title: "Customers", to: "/customers" },
      { title: "Resources", to: "/resources" },
      { title: "Pricing", to: "/pricing" },
      { title: "Contact", to: "/resources/contact" },
    ],
  },
  {
    // Legal column removed; links now live in footer bottom bar
    title: "",
    children: [],
  },
];
export const socialMedia = [
  {
    label: "Linkedin",
    path: "https://in.linkedin.com/company/babblebots",
    icon: LinkedinLogoIcon,
  },
  {
    label: "YouTube",
    path: "https://www.youtube.com/channel/UCPvbxGCZsxJwMiqmO9XWfdg",
    icon: YoutubeLogoIcon,
  },
];

export const officeAddress =
  "SINE Office, YP Rd, IIT Area, Powai, Mumbai, Maharashtra 400076";
